module.exports = __webpack_public_path__ + "fonts/Open_Sans-700-greek-ext28.6644a09.woff2";